import { DA_CATEGORIES } from '../../lib/daCategories';

import { ALL_COUNCILS, ALL_STATUS_KEYS } from './dashboardFilterOptions-v1';

export default function DashboardSearchControls({
  selectedCategories, councils, stFilt, selectedTrade, safeRanges, appTypeFilter,
  rawSearch, isSearchMode, theme, searchFocused, setSearchHelpOpen, searchInputRef,
  loading, searchLoading, resultCount, rememberSearchScroll, setRawSearch,
  setSearchFocused, setFilterDrawerOpen,
}) {
  const safeCats = Array.isArray(selectedCategories) ? selectedCategories : [];
  const activeFilterCount =
    (councils.length < ALL_COUNCILS.length ? 1 : 0) +
    (stFilt.length < ALL_STATUS_KEYS.length ? 1 : 0) +
    (selectedTrade ? 1 : safeCats.length < DA_CATEGORIES.length ? 1 : 0) +
    safeRanges.length +
    (appTypeFilter !== 'All' ? 1 : 0);
  const showSearchFilterBadge = Boolean((rawSearch || isSearchMode) && activeFilterCount > 0);
  return (
    <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
      <div style={{
        flex: 1, minWidth: 0, background: theme.bgCard,
        border: `1px solid ${searchFocused ? theme.accent + "66" : theme.border}`,
        borderRadius: 8, display: "flex", alignItems: "center",
        position: "relative", transition: "border-color 0.15s",
      }}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={theme.textMuted} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
          style={{ position: "absolute", left: 12, pointerEvents: "none", flexShrink: 0 }}>
          <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
        <button
          type="button"
          onMouseDown={e => e.preventDefault()}
          onClick={() => setSearchHelpOpen(true)}
          aria-label="How search works"
          title="How search works"
          style={{
            position: "absolute",
            left: 32,
            width: 24,
            height: 24,
            borderRadius: 999,
            border: `1px solid ${theme.border}`,
            background: `${theme.accent}12`,
            color: theme.accent,
            cursor: "pointer",
            fontFamily: "inherit",
            fontSize: 12,
            fontWeight: 850,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: 1,
          }}
        >
          i
        </button>
        <input
          ref={searchInputRef}
          type="text"
          enterKeyHint="search"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck={false}
          value={rawSearch || ''}
          onChange={e => {
            rememberSearchScroll();
            setRawSearch && setRawSearch(e.target.value);
          }}
          onFocus={() => {
            rememberSearchScroll();
            setSearchFocused(true);
          }}
          onBlur={() => setSearchFocused(false)}
          placeholder={loading ? 'Loading…' : searchLoading ? 'Searching…' : isSearchMode
            ? `${resultCount} result${resultCount !== 1 ? 's' : ''}`
            : 'Suburb, address or project reference'}
          aria-label="Search development applications"
          style={{
            flex: 1, minWidth: 0, width: "100%", boxSizing: "border-box", background: "transparent", border: "none", outline: "none",
            color: theme.text, fontSize: "var(--text-input, 16px)", fontFamily: "'DM Sans',sans-serif",
            padding: `12px ${showSearchFilterBadge ? (rawSearch ? 76 : 50) : 32}px 12px 62px`,
          }}
        />
        {showSearchFilterBadge && (
          <div
            aria-label={`${activeFilterCount} filter${activeFilterCount !== 1 ? 's' : ''} active while searching`}
            title={`${activeFilterCount} filter${activeFilterCount !== 1 ? 's' : ''} applied to search`}
            style={{
              position: "absolute",
              right: rawSearch ? 34 : 8,
              display: "inline-flex",
              alignItems: "center",
              gap: 4,
              minHeight: 22,
              padding: "2px 6px",
              borderRadius: 999,
              border: `1px solid ${theme.accent}66`,
              background: `${theme.accent}1f`,
              color: theme.accent,
              fontSize: 11,
              fontWeight: 800,
              pointerEvents: "none",
              lineHeight: 1,
            }}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M3 5h18l-7 8v5l-4 2v-7L3 5z"/>
            </svg>
            <span>{activeFilterCount}</span>
          </div>
        )}
        {rawSearch && (
          <button
            onMouseDown={e => e.preventDefault()} // prevent input blur before state clears
            onClick={() => {
              rememberSearchScroll();
              setRawSearch && setRawSearch('');
              // Re-focus the input so the user can immediately type a new search
              // without having to tap again (especially important on mobile where
              // clearing via button otherwise dismisses the keyboard)
              searchInputRef.current?.focus();
            }}
            aria-label="Clear search"
            style={{ position: "absolute", right: 8, background: "none", border: "none", cursor: "pointer", color: theme.textMuted, fontSize: 16, lineHeight: 1, padding: "2px 4px" }}
          >×</button>
        )}
      </div>
      <button
        onClick={() => setFilterDrawerOpen(true)}
        style={{
          background: activeFilterCount > 0 ? theme.accent : `${theme.accent}18`,
          border: `1px solid ${theme.accent}`,
          color: activeFilterCount > 0 ? theme.textDark : theme.accent,
          borderRadius: 8, padding: "12px 16px", fontSize: 14, fontWeight: 600,
          cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap",
        }}
      >
        {activeFilterCount > 0 ? `Filters (${activeFilterCount})` : "Filters"}
      </button>
    </div>
  );
}
